import * as grid from '@helpcenter/styles/src/grid';

export const iconDimension = grid.multiple(3).px;
